import React, { useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { faCommentAltLines } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import ResolvedModal from "~/stream/Comments/ResolvedModal";
import Menu from "~/ui/menu";
import { useModals } from "~/ui/modals";

import type { ResolvedComments_note$key } from "~/__generated__/ResolvedComments_note.graphql";

const noteFragment = graphql`
	fragment ResolvedComments_note on Note {
		id
	}
`;

export default function ResolvedComments({ note: noteKey }: { note: ResolvedComments_note$key }) {
	const modals = useModals();
	const note = useFragment(noteFragment, noteKey);

	const openResolvedCommentsModal = useCallback(
		() => modals.open(({ close }) => <ResolvedModal noteId={note.id} onClose={close} />),
		[modals, note],
	);

	return (
		<Menu.Item icon={faCommentAltLines} onSelect={openResolvedCommentsModal}>
			Resolved comments
		</Menu.Item>
	);
}
